import { Stack, TextField } from '@mui/material';
import { type MediaFrame } from '@provision/landing-page-ui';
import { isValidLandingPageUrl } from '@provision/landing-page-utils';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { ImageFrameEditor } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/image-frame-editor';
import {
  blockFieldName,
  type LandingPageFormValues,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface ImageUrlFieldProps {
  index: number;
  prefix: MediaFrame;
  label: string;
  helperText?: string;
  readOnly: boolean;
}

export const ImageUrlField = ({
  index,
  prefix,
  label,
  helperText,
  readOnly,
}: ImageUrlFieldProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const name = blockFieldName(index, `${prefix}ImageUrl`);
  const value = useWatch({ control, name });

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (fieldValue) =>
          !String(fieldValue ?? '').trim() ||
          isValidLandingPageUrl(String(fieldValue).trim()) ||
          'Enter a valid URL (https://…)',
      }}
      render={({ field, fieldState }) => (
        <Stack spacing={1.5}>
          <TextField
            {...field}
            value={field.value ?? ''}
            label={label}
            size="small"
            fullWidth
            disabled={readOnly}
            placeholder="https://example.com/image.jpg"
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message ?? helperText}
          />
          <ImageFrameEditor
            index={index}
            prefix={prefix}
            url={typeof value === 'string' ? value.trim() : ''}
            readOnly={readOnly}
          />
        </Stack>
      )}
    />
  );
};
